// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SystemDocumentsResolver } from '@services/resolvers/system-documents.resolver';
import { UserResolver } from '@services/resolvers/user.resolver';
import { SetUpComponent } from './set-up/set-up.component';
import { WelcomeToDDJComponent } from './welcome-to-ddj/welcome-to-ddj.component';

const routes: Routes = [
    {
        path: '',
        component: WelcomeToDDJComponent,
        resolve: {
            user: UserResolver,
        },
    },
    {
        path: 'setup',
        component: SetUpComponent,
        resolve: {
            user: UserResolver,
            requiredDocs: SystemDocumentsResolver,
        },
    },
    {
        path: 'setup/:next',
        component: SetUpComponent,
        resolve: {
            user: UserResolver,
            requiredDocs: SystemDocumentsResolver,
        },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class NewUserRoutingModule {}
